import { ReactComponent as NavDesktopLoanDetails } from "assets/images/v2/nav-desktop-loan-details.svg";

/** Loan-type prefix icon for sidebar rows. Purpose-specific icons deferred. */
export const getLoanTypeIcon = () => <NavDesktopLoanDetails />;
